import { render } from "./ItemListView.vue?vue&type=template&id=7bc1b8ce&scoped=true&ts=true"
import script from "./ItemListView.vue?vue&type=script&lang=ts"
export * from "./ItemListView.vue?vue&type=script&lang=ts"

import "./ItemListView.vue?vue&type=style&index=0&id=7bc1b8ce&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc1b8ce"]])

export default __exports__